/**
 * Excepciones de acceso a Twilio Online (por iderp).
 * Única lista a editar en front cuando se da acceso individual
 * sin marcar el permiso del puesto en Catálogos → Permisos.
 *
 * Quien tenga TwilioOnline en el menú (permisos_puestos) también entra,
 * aunque no esté en esta lista.
 */
export const TWILIO_ONLINE_EXCEPCIONES = [
  1963,
]

export function esExcepcionTwilioOnline (iderp) {
  const id = Number(iderp)
  if (Number.isFinite(id) && TWILIO_ONLINE_EXCEPCIONES.includes(id)) return true
  return TWILIO_ONLINE_EXCEPCIONES.includes(iderp)
}
